import * as React from 'react';
import { Icon, IconType } from '@next-components/bos-icon';
import { IDynamicListHeaderProps } from '../IDynamicListStock';
import { filterAndOrderCols } from '../DynamicListStock.utils';
import classNames from 'classnames';
import { checkboxColWidth, VehicleListStockStyled } from './VehicleListStock.styled';
import { upperFirst } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const ListHeaderStock = (props: IDynamicListHeaderProps) => {
  if (props.noHeader) return null;

  const columns = filterAndOrderCols(props.cols);
  const hasCheckboxCol = props.selectable && props.withCheckbox;
  const columnWidth = columns?.map((column) => column?.colWidth ?? '1fr');
  if (hasCheckboxCol) {
    columnWidth?.unshift(checkboxColWidth);
  }
 
  const sortIcon = props?.sortDirection === 'asc' ? IconType.ArrowUp : IconType.ArrowDown
  return (
    <VehicleListStockStyled
      columnWidth={columnWidth}
      className={classNames('header', {
        headerRow: props.isNewDynamicList,
        disabled: props.isHeaderDisable,
      })}
      withAccordion={props.withAccordion}>
      <div className="headerContainer">
        <div className="headerBottomContainer">
          <div className="grid-row header-inner">
            {hasCheckboxCol && <div className="selectable"></div>}
            {columns?.map((column) => (
              <div
                className={classNames({
                  sortable: !column?.noSort,
                })}
                key={`header_${column?.key || ''}_${uuidv4()}`}
                onClick={() => (column?.noSort ? {} : props.onSortChange(column?.key))}>
                {upperFirst(column?.header)}              
                {column?.key === "trackTraceCode" && (
                  <div style={{ maxWidth: 15, marginLeft: 5, display: 'inline-block' }}>
                    <Icon
                      icon={props?.isColumnClicked ? sortIcon : null}
                      height={18}
                      width={18}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
          <div></div>
        </div>        
      </div>
    </VehicleListStockStyled>
  );
};

ListHeaderStock.defaultProps = {
  isHeaderDisable: false,
};
